export default "__VITE_ASSET__Cg3GdtJd__"